import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { List } from 'immutable';
import { browserHistory } from 'react-router';

import FeedbackForm from 'components/FeedbackForm';
import { fetchQuestions, fetchSubmissionStatus, submitAnswers } from 'actions/feedback';
import {
  getFeedbackQuestions,
  answersLoading,
  feedbackSubmitted,
  feedbackSubmittedThisSession,
  submissionStatusLoading,
} from 'selectors/feedback';
import { SurveyIcon } from 'components/Icons';
import Page from '../container';
import { SubmittedMessage } from './styles';

const messages = defineMessages({
  title: {
    defaultMessage: 'Feedback',
  },
  thanks: {
    defaultMessage: 'Thank you for taking the time to leave feedback.',
  },
  alreadySubmitted: {
    defaultMessage: 'Feedback has already been submitted for this order.',
  },
});

const propTypes = {
  serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  fetchQuestions: PropTypes.func,
  questions: PropTypes.instanceOf(List),
  answersLoading: PropTypes.bool,
  submitAnswers: PropTypes.func,
  fetchSubmissionStatus: PropTypes.func,
  submitted: PropTypes.bool,
  submittedThisSession: PropTypes.bool,
  submissionStatusLoading: PropTypes.bool,
};

const Feedback = ({
  serviceId,
  fetchQuestions,
  fetchSubmissionStatus,
  questions,
  submitAnswers,
  answersLoading,
  submitted,
  submittedThisSession,
  submissionStatusLoading,
}) => {
  useEffect(() => {
    if (!serviceId) browserHistory.push('/');

    if (serviceId) {
      fetchSubmissionStatus();
    }
  }, [fetchSubmissionStatus, serviceId]);

  useEffect(() => {
    if (serviceId && questions.size === 0) {
      fetchQuestions(serviceId);
    }
  }, [fetchQuestions, questions.size, serviceId]);

  const message = submittedThisSession ? messages.thanks : messages.alreadySubmitted;

  const renderContent = () => {
    if (submissionStatusLoading) return <div />;

    if (submitted) {
      return (
        <SubmittedMessage>
          <FormattedMessage {...message} />
        </SubmittedMessage>
      );
    }

    if (questions.size > 0) {
      return (
        <FeedbackForm questions={questions.toJS()} onSubmit={submitAnswers} submitting={answersLoading} />
      );
    }

    return <div />;
  };

  return (
    <Page settingsPage={true} titleMessage={messages.title} Icon={SurveyIcon}>
      {renderContent()}
    </Page>
  );
};

Feedback.propTypes = propTypes;

export default connect(
  (state, { params }) => ({
    serviceId: params?.serviceId || false,
    questions: getFeedbackQuestions(state),
    answersLoading: answersLoading(state),
    submitted: feedbackSubmitted(state),
    submittedThisSession: feedbackSubmittedThisSession(state),
    submissionStatusLoading: submissionStatusLoading(state),
  }),
  { fetchQuestions, fetchSubmissionStatus, submitAnswers }
)(Feedback);
